import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import type { FieldKeyError } from '../store/field-key';
const FieldKeyErrorMessage = t0 => {
  const $0 = _c(8);
  const {
    error
  } = t0;
  let t1;
  if ($0[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "agentBuilder.canvas.fieldKey.errors"
    };
    $0[0] = t1;
  } else {
    t1 = $0[0];
  }
  const {
    t
  } = useTranslation("agents", t1);
  if (!error) {
    return null;
  }
  let t2;
  if ($0[1] !== error) {
    t2 = $ => $[error];
    $0[1] = error;
    $0[2] = t2;
  } else {
    t2 = $0[2];
  }
  let t3;
  if ($0[3] !== t || $0[4] !== t2) {
    t3 = t(t2);
    $0[3] = t;
    $0[4] = t2;
    $0[5] = t3;
  } else {
    t3 = $0[5];
  }
  let t4;
  if ($0[6] !== t3) {
    t4 = <span className="text-caption-1 text-error">{t3}</span>;
    $0[6] = t3;
    $0[7] = t4;
  } else {
    t4 = $0[7];
  }
  return t4;
};
export default FieldKeyErrorMessage;